export default __webpack_public_path__ + "static/media/Will Be Tasty.645327fc.png";